<template>
  <v-dialog
    v-model="value"
    :fullscreen="fullscreen"
    transition="dialog-bottom-transition"
    max-width="800"
    persistent
  >
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-btn icon dark @click="toggle()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items> </v-toolbar-items>
      </v-toolbar>
      <div class="my-2 mx-6">
        <slot></slot>
      </div>
      <v-divider></v-divider>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value", "show", "title", "showFooter", "disableScroll","fullscreen"],
  data() {
    return {
      titulo: "",
    };
  },
  mounted: function () {
    this.titulo = this.title;
    /*document.addEventListener("keydown", (e) => {
            if (this.show && e.keyCode == 27) {
                this.close()
            }
        })*/
  },
  computed: {
    showModal() {
      return this.show;
    },
    scroll() {
      if (this.disableScroll) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    /*toggle() {
            let toggleValue = !this.showModal;
            this.$emit('toggle',toggleValue);
        },*/
    toggle() {
      this.$emit("input", !this.value);
    },
    setTitle(value) {
      this.titulo = value;
    },
  },
};
</script>